import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export default function Renderer({ scenarioUrl, isNavEnabled, location, hideUI, onLocationChange }) {
  const exercise = useSelector(state => state.exercise.exercise);
  const iframeRef = useRef(null);
  
  let url = scenarioUrl;

  if (url && (url.startsWith("/") || url.indexOf('/api') === 0)) {
    const { companyId, scenario } = exercise;
    url = `${window.location.origin}/api/scenarios/${companyId}/${scenario.id}/archive?token=${localStorage.token}`;
  }

  const iframeSrc = `/webclient/?url=${encodeURIComponent(url)}${hideUI ? '&hide_ui=true' : ''}`;

  useEffect(() => {
    const iframe = iframeRef.current;
    if (location && iframe && iframe.contentWindow && typeof iframe.contentWindow.on === 'function') {
      iframe.contentWindow.on('user_location_update', JSON.stringify({ location: location }), '');
    }
  }, [location]);

  useEffect(() => {
    function handleLocationUpdate(e) {
      if (onLocationChange && e.detail?.location?.id) {
        onLocationChange(e.detail.location);
      }
    }
    window.addEventListener('player_user_location_update', handleLocationUpdate);
    return () => window.removeEventListener('player_user_location_update', handleLocationUpdate);
  }, [onLocationChange]);

  return (
    <div className={'simPlace' + (isNavEnabled ? '' : ' simPlace--locked')}>
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="SimPreview"
      />
    </div>
  );
}

